/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Recentdeliveries_Title1Inputs */

const he_extension_popup_recentdeliveries_title1 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התראות אחרונות`)
};

const en_extension_popup_recentdeliveries_title1 = /** @type {(inputs: Extension_Popup_Recentdeliveries_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recent alerts`)
};

/**
* | output |
* | --- |
* | "Recent alerts" |
*
* @param {Extension_Popup_Recentdeliveries_Title1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_recentdeliveries_title1 = /** @type {((inputs?: Extension_Popup_Recentdeliveries_Title1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Recentdeliveries_Title1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_recentdeliveries_title1(inputs)
	return en_extension_popup_recentdeliveries_title1(inputs)
});
export { extension_popup_recentdeliveries_title1 as "extension_popup_recentDeliveries_title" }